import React from 'react';
import { FunctionField } from 'react-admin';
import moment from 'moment';
import { setDefaultDateFormat } from '../../../../../utils';

export const getLastUpdatedDate = (createdAt, updatedAt, childrenUpdatedAt) => {
  const isUpdatedAtValidDate = moment(updatedAt).isValid();
  const isChildrenUpdatedAtValidDate = moment(childrenUpdatedAt).isValid();

  if (!isUpdatedAtValidDate && !isChildrenUpdatedAtValidDate) {
    return setDefaultDateFormat(createdAt);
  } else if (isUpdatedAtValidDate && isChildrenUpdatedAtValidDate) {
    return updatedAt > childrenUpdatedAt ?
      setDefaultDateFormat(updatedAt) : setDefaultDateFormat(childrenUpdatedAt);
  } else if (isUpdatedAtValidDate) {
    return setDefaultDateFormat(updatedAt);
  } else {
    return setDefaultDateFormat(childrenUpdatedAt);
  }
};

const LastUpdatedField = ({ record: { updatedAt, createdAt, childrenUpdatedAt } }) => {
  return (
    <FunctionField render={() => getLastUpdatedDate(createdAt, updatedAt, childrenUpdatedAt)}/>
  );

};

export default LastUpdatedField;
